export default {"src":"/_next/static/media/check.938ed495.svg","height":294,"width":293,"blurWidth":0,"blurHeight":0};